import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetProceduresList,
	GetProceduresListModel,
	GetProceduresListParams,
} from 'domain/usecases/private/my-hospitalization/get-procedures-list';

export class RemoteGetProceduresList implements GetProceduresList {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetProceduresListModel>,
	) {}

	async get({signal, ...params}: GetProceduresListParams): Promise<GetProceduresListModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
